/**
 * Image + Text block entry.
 *
 * Importing the SCSS here makes Vite bundle the block's CSS. GSAP is lazy-loaded
 * only when the block is present and motion is allowed.
 */

import './index.scss';

const imageTextBlocks = document.querySelectorAll('.image-text');

if (imageTextBlocks.length) {
	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	if (!reduceMotion) {
		imageTextBlocks.forEach((block) => {
			if (block.getBoundingClientRect().bottom > 0) {
				block.dataset.animate = '';
			}
		});

		(async () => {
			const { gsap } = await import('gsap');
			const { ScrollTrigger } = await import('gsap/ScrollTrigger');

			gsap.registerPlugin(ScrollTrigger);

			document.querySelectorAll('.image-text[data-animate]').forEach((block) => {
				const ctx = gsap.context(() => {
					const media = block.querySelector('.image-text__media');
					const content = block.querySelector('.image-text__content');

					if (media) {
						gsap.to(media, {
							opacity: 1,
							scale: 1,
							duration: 1,
							ease: 'power3.out',
							scrollTrigger: {
								trigger: block,
								start: 'top 85%',
								once: true,
							},
						});
					}

					if (content) {
						gsap.to(content, {
							opacity: 1,
							y: 0,
							duration: 0.8,
							ease: 'power3.out',
							scrollTrigger: {
								trigger: block,
								start: 'top 85%',
								once: true,
							},
						});
					}
				}, block);

				block._gsapCtx = ctx;
			});
		})();
	}
}
